<template>
  <div class="flex items-center gap-2">
    <button
      :id="checkboxId"
      type="button"
      role="checkbox"
      :aria-checked="Boolean(checked)"
      :aria-labelledby="checkboxLabelId"
      :aria-describedby="descriptionId"
      :disabled="disabled"
      :class="[
        'flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border-2 transition-all duration-200',
        checked
          ? 'tb-ci-checkbox-on'
          : 'border-gray-200 bg-white tb-ci-checkbox-off dark:border-gray-700 dark:bg-gray-900',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
      ]"
      @click="toggle"
    >
      <svg
        v-if="checked"
        class="h-3.5 w-3.5 text-white"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="3"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
      </svg>
    </button>
    <label
      v-if="label || $slots.default"
      :id="checkboxLabelId"
      :for="checkboxId"
      :class="[
        'cursor-pointer select-none text-sm text-gray-900 dark:text-white',
        disabled ? 'cursor-not-allowed opacity-50' : '',
      ]"
      @click.prevent="onLabelClick"
    >
      <slot>{{ label }}</slot>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    modelValue: boolean | unknown[]
    value?: unknown
    disabled?: boolean
    label?: string
    id?: string
    descriptionId?: string
  }>(),
  { disabled: false },
)

const emit = defineEmits<{ 'update:modelValue': [value: any] }>()

const checkboxId = computed(() => props.id ?? `cb-${Math.random().toString(36).slice(2)}`)
const checkboxLabelId = computed(() => `${checkboxId.value}-label`)
const checked = computed(() => (Array.isArray(props.modelValue) ? props.modelValue.includes(props.value) : props.modelValue))

function toggle(): void {
  if (props.disabled) return
  if (Array.isArray(props.modelValue)) {
    const next = checked.value
      ? props.modelValue.filter((entry) => entry !== props.value)
      : [...props.modelValue, props.value]
    emit('update:modelValue', next)
    return
  }
  emit('update:modelValue', !props.modelValue)
}

function onLabelClick(): void {
  toggle()
}
</script>
